import { addSurveyAnswers } from "@utils/redux/slices/surveyAnswers";
import { resetCurrentSurvey } from "src/hooks/survey";
import { resolveValue } from "src/pageDefinitions/values";
import { trackEvent } from "src/utils/api/tracker";
import { logDebug } from "src/utils/logging";
import { isCheckoutTimerExpired } from "src/utils/checkoutTimer";
import { ActionHandler, ActionHandlerParams } from "..";
import { getPageSetSurvey } from "./util";

type StartSurveyParams = {
  eventName?: string;
};

export const onStartSurvey: ActionHandler = ({
  pageSet,
  page,
  store,
  params = {},
}: {
  params?: StartSurveyParams;
} & ActionHandlerParams) => {
  const survey = getPageSetSurvey(pageSet, page);
  const eventName = params.eventName || `Started${survey.name}`;
  trackEvent(eventName);
  const { surveyNameSpace } = survey;
  if (surveyNameSpace) {
    logDebug(`Loading survey answers from ${surveyNameSpace}`);
    const lookupValue = resolveValue(surveyNameSpace, store.getState());
    if (
      lookupValue &&
      (surveyNameSpace !== "userData.purchaseSurveyAnswers" ||
        !isCheckoutTimerExpired(store.getState().userData))
    ) {
      store.dispatch(addSurveyAnswers(lookupValue));
      resetCurrentSurvey(lookupValue);
      return;
    }
  }
  resetCurrentSurvey();
};
